module.exports = __webpack_public_path__ + "img/reg.df6e8624.png";